import { Component, OnInit } from "@angular/core";
import { List } from "linqts";
import { SmConstants } from "../sm/sm.constants";
import { AppConstants } from "../../app.constant";
import { MenusService } from "../../core/service/menus.service";
import { Broadcast } from "../../core/events/broadcast";
import { SyncDataService } from "../../core/service/syncdata.service";
import { LocalStorage } from "../../core/helper/localStorage";
import { GenEnum } from "../shared/general.enum";
import { Router, NavigationExtras, ActivatedRoute } from "@angular/router";
import { Jsonp } from "@angular/http";
import { favoriteService } from "../forms/sms/menuview/Favorite.service";
import { ThrowStmt } from "@angular/compiler/src/output/output_ast";

@Component({
  moduleId: module.id,
  selector: "sidebar-left",
  templateUrl: "../shell-templates/sidebar-left.component.html",
})
export class SidebarLeftComponent {
  urlid: string;
  returnmenuid: number;
  menuid: any;
  private SyncData: SyncDataService;
  tree: Array<any>;
  FavouriteTree: Array<any>;
  localStorage: LocalStorage;
  name: any;
  imageSource: any;
  url: string;
  category: any;
  model: any = {};
  reportUrl: any;
  title = "Navigation Menu";
  entityName: String;
  protected broadcast: Broadcast;

  constructor(
    private menusService: MenusService,
    private router: Router,
    private route: ActivatedRoute,
    private favoriteService: favoriteService
  ) {
    this.broadcast = AppConstants.injector.get(Broadcast);
    this.SyncData = AppConstants.injector.get(SyncDataService);
    this.localStorage = AppConstants.injector.get(LocalStorage);
    this.imageSource =
      AppConstants.urls.api.base.replace("api/", "") + GenEnum.Image.imageUrl;
    // this.reportUrl = AppConstants.urls.api.reportUrl;
  }

  async ngOnInit() {
    let rute = "?";

    for (var key in localStorage) {
      let val = this.localStorage.get(key);
      66;
      if (
        val &&
        val !== undefined &&
        val !== null &&
        typeof val === "string" &&
        val[0] !== "[" &&
        val[0] !== "{"
      ) {
        rute += key + "," + val + "&&";
      }
    }

    this.reportUrl = AppConstants.urls.api.reportNGUrl + rute;
    this.entityName = this.localStorage.get("ClientStxt");

    await this.getMenu();
    this.model.userclients = localStorage.getItem("userclients");
    await this.getclientimage();

    this.route.queryParams.subscribe((params) => {
      this.returnmenuid = Number(params.menuid);
    });
  }

  getSubMenu(event, menutype: number) {
    if (menutype == 1) {
      this.broadcast.publish<string>("submenu", "");
      this.broadcast.publish<string>("menu", event.currentTarget.innerText);
    } else if (menutype == 2)
      this.broadcast.publish<string>("submenu", event.currentTarget.innerText);
  }
  resetTitle() {
   this.localStorage.remove('modulename');

    // this.title = ''; // Reset the title when clicking 'Home'
    }

  async getMenu() {
    const dto = await this.menusService.getMenu();

    if (dto.IsSuccess) {
      this.tree = dto.Data;
    }
  }

  collapse() {
    this.SyncData.clear();
    document
      .getElementsByClassName("sidebar-mini")
      .item(0)
      .classList.add("sidebar-collapse");
  }

  async getclientimage() {
    let UserInfo = JSON.parse(this.localStorage.get("utuser"));

    this.url = this.localStorage.get("EntityLogo");
    if (UserInfo) {

          this.name =
        UserInfo.fullname === undefined || UserInfo.fullname === ""
          ? "-"
          : UserInfo.fullname;
      if (UserInfo.lov1) {
        this.category =
          UserInfo.lov1.ltxt === undefined || UserInfo.lov1.ltxt === ""
            ? "-"
            : UserInfo.lov1.ltxt;
      }
    }
  }
  
 
  async getID(event) {
    debugger;
    this.menusService.dashboards = [];

    if (event.currentTarget.id === "dashboard") {
      this.router.navigate(["home"]);
      this.localStorage.remove('modulename');
    } else if (event.currentTarget.id) {
      this.menuid = event.currentTarget.id;

      let navigationExtras: NavigationExtras = {
        queryParams: {
          menuid: this.menuid,
          menucollection: JSON.stringify(this.tree),
        },
        replaceUrl: false,
      };

      let jsonData = JSON.parse(JSON.stringify(this.tree));
      let filterData = jsonData.filter((o) => o.id === Number(this.menuid))[0];
       
      let modulename = this.localStorage.get('modulename')
      let screenname = this.localStorage.get('screenname')
       
      if(modulename || screenname){
        
        this.localStorage.remove('modulename');
        this.localStorage.remove('screenname');
         
      }
       
      this.localStorage.set('modulename',filterData.label);
      if (filterData && filterData.children) {
        let dashboardData = filterData.children.filter(
          (o) => o.menucatid === GenEnum.Menucategory.Dashboard
        )[0];
        var active = document.getElementById("mainmenu");
        active.classList.add("activeclass");

        var dbmenu = document.getElementById("dashboardmenu");
        dbmenu.classList.remove("activeclass");

        if (dashboardData && dashboardData.children) {
          this.menusService.dashboards = dashboardData.children;
        }
      }
      this.router.navigate(["menuview"], navigationExtras);
      // this.localStorage.remove('modulename');
      
   
    }
    }
    

  async FavouriteEvent(event) {
    var utuser = JSON.parse(localStorage.getItem("utuser"));
    if (event.currentTarget.id) {
      this.menuid = event.currentTarget.id;
      await this.getFavouriteScreeen(utuser.userid, "null");
      if (this.menuid === "1001") {
        let navigationExtras: NavigationExtras = {
          queryParams: {
            menuid: this.menuid,
            menucollection: JSON.stringify(this.FavouriteTree),
          },
          replaceUrl: false,
        };
        this.router.navigate(["menuview"], navigationExtras);
      }
    }
  }

  async getFavouriteScreeen(userid, menuid) {
    this.FavouriteTree = [];
    const dto = await this.favoriteService.getFavouriteScreen(userid, menuid);
    if (dto.IsSuccess) {
      this.FavouriteTree = dto.Data;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shell/shell-components/sidebar-left.component.ts